<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { viewComponentRegistry } from 'src/components/Sidepanel/view-registry';

	export let device: Device;

	$: component = viewComponentRegistry?.['relay']?.['advanced'];
</script>

{#if component}
	<svelte:component this={component} {device} />
{/if}
